export class Graduacao {
  id = 0;
  idSalario = 1;
  graduacao = '';
  sigla = '';
}
